import { photoUrlBase } from '../constants';

type GetFullPhotoUrl = (baseUrl: string) => string;

export const getPhotoUrl: GetFullPhotoUrl = baseUrl =>
	baseUrl.includes('https') ? baseUrl : `${photoUrlBase}${baseUrl}`;

type GetPopupPhotoUrl = (baseUrl: string) => string;
export const getPopupPhotoUrl: GetPopupPhotoUrl = baseUrl => {
	switch (baseUrl) {
		case 'https://cdn.leroymerlin.ru/lmru/image/upload/site/M7oyyXULdkeLpDoAcRhKow/services-platform-regional-landing-ustanovka-dveri.jpg':
			return 'https://cdn.leroymerlin.ru/lmru/image/upload/site/BT3BCJcSIUmnJm9phT7Lbg/services-platform-regional-landing-ustanovka-dveri-popup.jpg';
		case 'https://cdn.leroymerlin.ru/lmru/image/upload/site/05q1mLYEiUWDYoiO6R68Kg/services-platform-regional-landing-ustanovka-garderobnyh-sistem.jpg':
			return 'https://cdn.leroymerlin.ru/lmru/image/upload/site/KauZSVZhDEq-W7Tf3KLMCA/services-platform-regional-landing-ustanovka-garderobnyh-sistem-popup.jpg';
		case 'https://cdn.leroymerlin.ru/lmru/image/upload/site/wuPqsmmYbECe2dqjs8UKTA/services-platform-regional-landing-ustanovka-kuhon.jpg':
			return 'https://cdn.leroymerlin.ru/lmru/image/upload/site/EcphZzZ_GkuSz9i8VpLqaA/services-platform-regional-landing-ustanovka-kuhon-popup.jpg';
		default:
			return `${baseUrl.slice(0, baseUrl.indexOf('.jpg'))}-popup.jpg`;
	}
};
